import React, { useState, useEffect } from 'react';
import {
    Button,
    Typography,
    Grid,
    Card,
    CardContent,
    CardActionArea,
    Box
} from '@mui/material';
import { useSnackbar } from 'notistack';
import { tipoTechoService } from '../../services/tipoTechoService';
import techo1 from '../../img/tipotechos/techo1.png';
import techo2 from '../../img/tipotechos/techo2.png';
import techo3 from '../../img/tipotechos/techo3.png';
import techo4 from '../../img/tipotechos/techo4.png';
import techo5 from '../../img/tipotechos/techo5.png';
import techo6 from '../../img/tipotechos/techo6.png';

const Paso3TipoTecho = ({ onNext, onBack, initialData }) => {
    const [tiposTecho, setTiposTecho] = useState([]);
    const [selected, setSelected] = useState(initialData.tipoTecho || null);
    const [loading, setLoading] = useState(true);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        const cargarTiposTecho = async () => {
            try {
                const response = await tipoTechoService.obtenerTodos();
                setTiposTecho(response.data);
            } catch (error) {
                enqueueSnackbar('Error al cargar tipos de techo', { variant: 'error' });
            } finally {
                setLoading(false);
            }
        };

        cargarTiposTecho();
    }, [enqueueSnackbar]);

    const handleSelect = (tipo) => {
        setSelected(tipo);
    };

    const handleContinue = () => {
        if (!selected) {
            enqueueSnackbar('Debes seleccionar un tipo de techo', { variant: 'error' });
            return;
        }
        onNext({ tipoTecho: selected });
    };

    const getTechoImage = (tipoId) => {
        const images = {
            1: techo1,
            2: techo2,
            3: techo3,
            4: techo4,
            5: techo5,
            6: techo6
        };
        return images[tipoId];
    };

    return (
        <Box sx={{ maxWidth: '800px', margin: '0 auto', px: 2 }}>
            <Typography variant="h5" gutterBottom sx={{ textAlign: 'center', fontSize: '1.3rem', mb: 2 }}>
                Selecciona el tipo de techo
            </Typography>
            <Typography variant="body1" gutterBottom sx={{ mb: 4, textAlign: 'center', fontSize: '0.85rem' }}>
                Esta información nos ayuda a determinar la mejor instalación
            </Typography>

            {loading ? (
                <Typography align="center">Cargando opciones...</Typography>
            ) : (
                <Grid container spacing={2} justifyContent="center">
                    {tiposTecho.map((tipo) => (
                        <Grid item xs={6} sm={4} md={3} key={tipo.Id}>
                            <Card
                                sx={{
                                    border: selected?.Id === tipo.Id ? '2px solid #1976d2' : '1px solid #e0e0e0',
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                    p: 1.5,
                                    minHeight: '180px',
                                    maxWidth: '180px',
                                    margin: '0 auto',
                                    '&:hover': {
                                        transform: 'translateY(-3px)',
                                        boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                                        transition: 'all 0.2s ease'
                                    }
                                }}
                            >
                                <CardActionArea
                                    onClick={() => handleSelect(tipo)}
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        height: '100%',
                                        width: '100%',
                                        p: 0.5
                                    }}
                                >
                                    <Box
                                        component="img"
                                        src={getTechoImage(tipo.Id)}
                                        alt={tipo.Nombre}
                                        sx={{
                                            width: '50px',
                                            height: '50px',
                                            objectFit: 'contain',
                                            mb: 1.5
                                        }}
                                    />
                                    <Box sx={{
                                        flexGrow: 1,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center'
                                    }}>
                                        <Typography variant="h6" sx={{
                                            fontSize: '0.85rem',
                                            fontWeight: 500,
                                            mb: 0.5,
                                            lineHeight: '1.2'
                                        }}>
                                            {tipo.Nombre}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary" sx={{
                                            fontSize: '0.7rem',
                                            lineHeight: '1.2'
                                        }}>
                                            {tipo.Descripcion}
                                        </Typography>
                                    </Box>
                                </CardActionArea>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            )}

            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                mt: 4,
                px: 1
            }}>
                <Button
                    onClick={onBack}
                    sx={{
                        fontSize: '0.8rem',
                        px: 2,
                        py: 0.8,
                        minWidth: '100px'
                    }}
                >
                    Atrás
                </Button>
                <Button
                    variant="contained"
                    onClick={handleContinue}
                    disabled={!selected}
                    sx={{
                        fontSize: '0.8rem',
                        px: 2,
                        py: 0.8,
                        fontWeight: 500,
                        minWidth: '100px'
                    }}
                >
                    Continuar
                </Button>
            </Box>
        </Box>
    );
};

export default Paso3TipoTecho;